import { mapGetters, mapActions } from 'vuex'
import { PAGES, UIDS } from '../content-types'

const type = PAGES.GLOBAL_SETTINGS
const UID = UIDS.GLOBAL_SETTINGS

export const GlobalSettings = {
  name: 'BrandComponent',
  computed: {
    ...mapGetters('prismic', ['getPage', 'getBlock'])
  },
  methods: {
    ...mapActions('prismic', ['setBlock', 'setPage']),
    setLogoImage() {
      if (
        this.page &&
        this.page.main &&
        this.page.main.logo &&
        this.page.main.logo.url
      ) {
        const logo = this.page.main.logo.url
        const logoOnBlueMenu = this.page.main.logo_on_blue_menu && this.page.main.logo_on_blue_menu.url
          ? this.page.main.logo_on_blue_menu.url
          : logo

        this.$store.commit('zenith-ui/setLogo', {
          url: logo,
          urlOnBlueMenu: logoOnBlueMenu
        })
      }
    },
    setLogo160Image() {
      if (
        this.page &&
        this.page.main
      ) {
        const baseUrl = this.page.main.logo_160 && this.page.main.logo_160.url
          ? this.page.main.logo_160.url
          : ''
        const urlOnBlueMenu = this.page.main.logo_160_on_blue_menu && this.page.main.logo_160_on_blue_menu.url
          ? this.page.main.logo_160_on_blue_menu.url
          : baseUrl
        const isVisible = this.page.main.logo_160_visible
        this.$store.commit('zenith-ui/setLogo160', {
          baseUrl,
          urlOnBlueMenu,
          isVisible
        })
      }
    }
  },
  async serverPrefetch() {
    await this.setPage({ type, uid: UID })

    this.page = this.getPage({ type, uid: UID })

    this.setLogoImage()
    this.setLogo160Image()
  },
  async created() {
    this.page = this.getPage({ type, uid: UID })
    if (!this.page) {
      await this.setPage({ type, uid: UID })
      this.page = this.getPage({ type, uid: UID })
    }

    this.setLogoImage()
    this.setLogo160Image()
  }
}
